document.getElementById("popup-video").style.display="none";
document.addEventListener("DOMContentLoaded", function(){
    setTimeout(function(){
        let videosound = document.getElementById("popup-video");
        document.getElementById("popup").style.display = "block";
        videosound.style.display="block";
       
        
        
    }, 1500);

});

function closePopup(){
    let popupvideo = document.getElementById("popup-video");
    document.getElementById("popup").style.display="none";
    
    popupvideo.pause();
}